export default "__VITE_ASSET__C4x$OOpv__"